import { DottedIcon } from '@assets/icons';
import { ResyncBlueIcon } from '@assets/icons/index';
import { Flex, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { TextRegular } from '@components/typography';
import moment from 'moment';
import styles from './styles.module.css';

const ActionButton = ({ values }) => {
    const onClickResync = () => {
        console.log(values);
    };

    return (
        <Flex justifyContent={'center'} width={'100%'} className={styles['column__container']}>
            <Menu>
                <MenuButton
                    as={IconButton}
                    aria-label="Options"
                    variant="outline"
                    borderColor="transparent"
                    width="fit-content"
                    paddingX="0px"
                    icon={<DottedIcon />}
                />
                <MenuList minWidth="unset" padding="0" overflow="clip" borderColor={'neutral.200'}>
                    <MenuItem borderRadius="inherit" onClick={onClickResync}>
                        <Flex gap={'12px'} color={'paragon.500'}>
                            <ResyncBlueIcon />
                            Resync
                        </Flex>
                    </MenuItem>
                </MenuList>
            </Menu>
        </Flex>
    );
};

export const getTableList = (selloutValue) => [
    {
        name: 'Sellout Date',
        value: 'sellout_date',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>
                    {value ? moment(value).format('DD MMM YYYY') : '-'}
                </TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Brand',
        value: 'brand',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Product Barcode',
        value: 'barcode',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Product Name',
        value: 'name',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Sellout Qty',
        value: 'sellout_qty',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: `Sellout Value (${selloutValue?.id === 'sellout_value_store' ? 'Cust.' : 'HET'})`,
        value: selloutValue?.id ?? 'sellout_value',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>
                    {!value || Number.isNaN(Number(value)) || Number(value) === 0
                        ? 'Rp-'
                        : Number(value)
                              .toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })
                              .replace(/\s+/, '')}
                </TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Agg. Level',
        value: 'agg',
        width: 125,
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular p="4px 6px" className={styles['column__text']}>
                    {value?.replaceAll(/\b\w/g, (char) => char.toUpperCase()) ?? '-'}
                </TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Last Sync Date',
        value: 'last_sync',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>
                    {value
                        ? moment.parseZone(value).utcOffset('+07:00').format('DD MMM YYYY - HH:mm:ss') + ' WIB'
                        : '-'}
                </TextRegular>
            </Flex>
        ),
    },
    // {
    //     name: 'Action',
    //     width: 100,
    //     justifyContent: 'center',
    //     component: ({ values }) => <ActionButton values={values} />,
    // },
];
